import {DataFetcher} from '@aboutyou/data-fetcher';
import {TreeNavigationItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/tree_navigation_item.types';
import {originClick} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import {
  ExtendedTreeItem,
  NavigationTree,
  NavigationTreeProps,
} from '../../../features/NavigationTree/NavigationTree';
import {NavigationTreeLoading} from '../../../features/NavigationTree/NavigationTreeLoading';
import {FIRST_PRODUCT_ID_PARAM} from '../../../features/firstProductId/useFirstProductIds';
import {useCouponPath} from '../hooks/useCouponPath';
import {useCouponLandingPageCategoryTreeNavigation} from './useCouponLandingPageCategoryTreeNavigation';

interface CategoryTreeProps {
  className?: string;
}

export const CouponLangingPageNavigationTree: React.FC<CategoryTreeProps> = ({
  className,
}) => {
  return (
    <DataFetcher
      request={useCouponLandingPageCategoryTreeNavigation()}
      Error={null}
      Loading={NavigationTreeLoading}
      View={CouponLangingPageNavigationTreeView}
      viewProps={{
        className,
        trackOriginKey: 'category_tree_side' as originClick,
        testId: 'couponLandingPageNavigationTree',
        excludeUrlParams: [
          FIRST_PRODUCT_ID_PARAM,
        ] as NavigationTreeProps['excludeUrlParams'],
      }}
    />
  );
};

const CouponLangingPageNavigationTreeView: React.FC<NavigationTreeProps> = ({
  categoryTree,
  ...otherProps
}) => {
  const normalizeNodes = useNormalizeNodes();

  return (
    <NavigationTree
      categoryTree={categoryTree.map(normalizeNodes)}
      {...otherProps}
    />
  );
};

const useNormalizeNodes = () => {
  const couponPath = useCouponPath();

  const normalizeNodes = (node: TreeNavigationItem): ExtendedTreeItem => ({
    ...node,
    category: {
      ...node.category,
      targetPath: couponPath(node.category.id),
    },
    children: node.children.map(normalizeNodes),
  });

  return normalizeNodes;
};
